import { render, staticRenderFns } from "./index3.5.vue?vue&type=template&id=e88c5c32&scoped=true"
import script from "./index3.5.vue?vue&type=script&lang=js"
export * from "./index3.5.vue?vue&type=script&lang=js"
import style0 from "./index3.5.vue?vue&type=style&index=0&id=e88c5c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88c5c32",
  null
  
)

export default component.exports